import { ActionMap, StoreActions } from '../reducer.types';
import {
  GenerationFormState,
  GenerationFormStorePayload,
  GenerationFormStoreActionTypes
} from './GenerationFormStore.types';

export type GenerationFormStoreActions =
  ActionMap<GenerationFormStorePayload>[keyof ActionMap<GenerationFormStorePayload>];

export const GenerationFormStoreReducer = (state: GenerationFormState, action: StoreActions) => {
  switch (action.type) {
    case GenerationFormStoreActionTypes.AddNotesHistory:
      return state;
    case GenerationFormStoreActionTypes.SetSelectedModel:
      return {
        ...state,
        selectedModelId: action.payload
      };
    case GenerationFormStoreActionTypes.SetWorkItemVolume:
      return {
        ...state,
        workItemVolume: action.payload
      };
    default:
      return state;
  }
};
